import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { AgGridReact } from 'ag-grid-react';
import { Grid } from '@mui/material';


const FileManagerList = (props) => {

    // Se recuperan las props del componente
    const { 
        
        // datos (listados, individuales)
        rowConfig,
        columnConfig,

        // hancleClicks

        // Funciones

    } = props

    // Hook: para poder filtrar datos de la tabla
    const gridRef = useRef();

    // Hook: Para definir un array que se usara para listar la informacion de la BD
    const [rowData, setRowData] = useState([]);

    // Hook: Para definir un array que se usara para configurar los encabezados de columna
    const [colDefs, setColDefs] = useState([]);

    // Hook: Para distribuir las columnas en toda la tabla
    const autoSizeStrategy = useMemo(() => {
        return {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
        };
    }, []);

    // Hook: Para filtrar por cualquier columna de la tabla
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filtro').value
        );
    }, []);

    // Se settea la información en donde corresponde
    useEffect(() => {
        
        // setColDefs([...columnConfig])
        setRowData([...rowConfig])

    }, [rowConfig]);
    
    useEffect(() => {
        
        setColDefs([...columnConfig])

    }, []);

    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            {/* <Row>
                <Col md="12">
                    <InputGroup>
                        <InputGroupText>
                            Buscar:
                        </InputGroupText>
                        <Input 
                            id='filtro'
                            name='filtro'
                            onInput={onFilterTextBoxChanged}
                            type='text'
                        />
                    </InputGroup>
                </Col>
            </Row> */}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                    <div className="ag-theme-quartz" style={{ height: '60vh', margin: 0}}>
                        {/* The AG Grid component */}
                        <AgGridReact 
                            ref={gridRef}//PROPIEDAD PARA PERMITIR FILTRAR EN LA TABLA
                            rowData={rowData} 
                            columnDefs={colDefs} 
                            pagination={true}
                            paginationAutoPageSize={true}//PROPIEDAD PARA COLOCAR CANTIDAD DE FILAS QUE PERMITA EL TAMAÑO DE PANTALLA 
                            autoSizeStrategy={autoSizeStrategy}//PROPIEDAD PARA QUE LAS COLUMNAS LLENEN TODA LA TABLA
                            // localeText={AG_GRID_LOCALE_ES}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export {
    FileManagerList
}